/**
 * 편집 왕복 규약(spec 설계 결정 5): 편집 진입 시 렌더된 DOM에서 병원 버튼을 그대로 저장하면
 * 실제 병원명만 남고 alias가 소실돼 재변환이 불가능해진다. 추출 단계에서 병원 버튼을
 * TipTap HospitalNode가 인식할 수 있는 span[data-hospital-alias][data-hospital-link]로 바꾼다
 * (ReferenceButton 처리와 동형).
 *
 * 순수 DOM 조작이라 jsdom에서 단위 테스트가 가능하다.
 */

/**
 * 주어진 루트 엘리먼트(보통 clone)에서 병원 버튼을 span으로 치환한다.
 * `button[data-hospital-alias][data-hospital-link]` → `span[data-hospital-alias][data-hospital-link]`
 * (textContent = 실제 병원명, alias 보존).
 */
export function convertHospitalButtonsToSpans(root: HTMLElement): void {
  const buttons = root.querySelectorAll(
    "button[data-hospital-alias][data-hospital-link]"
  );

  buttons.forEach((button) => {
    const alias = button.getAttribute("data-hospital-alias");
    const link = button.getAttribute("data-hospital-link");

    if (alias && link) {
      const span = document.createElement("span");
      span.setAttribute("data-hospital-alias", alias);
      span.setAttribute("data-hospital-link", "true");
      span.textContent = button.textContent || "";

      button.parentNode?.replaceChild(span, button);
    }
  });
}

/**
 * 처방전 지칭 버튼을 평문 텍스트로 되돌린다(편집 진입 추출 · spec 설계 결정 11).
 *
 * 처방전 버튼은 텍스트(`처방전N`) 자체가 식별자라 TipTap 노드·data 속성을 두지 않는다.
 * 편집 저장 시 평문 `처방전N`으로 남아도 재렌더에서 재버튼화되므로, 추출 단계에서 버튼 껍데기를
 * 벗겨 깨끗한 텍스트만 남긴다(참고문헌·병원 버튼은 이미 span으로 변환된 뒤라 여기 대상이 아니다).
 */
export function unwrapPrescriptionButtons(root: HTMLElement): void {
  const buttons = root.querySelectorAll("button");
  buttons.forEach((button) => {
    if (button.hasAttribute("data-reference-id") || button.hasAttribute("data-hospital-alias")) {
      return;
    }
    const text = (button.textContent || "").trim();
    if (/^처방전\d+$/.test(text)) {
      button.parentNode?.replaceChild(document.createTextNode(text), button);
    }
  });
}
